import Image from "next/image";

import { FC } from "react";

import { SwiperSlide } from "swiper/react";
import type { SwiperProps } from "swiper/react";
import { Autoplay } from "swiper/modules";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";

import Carousel from "components/Carousel";

import styles from "./styles";

interface Logo {
  name: string;
  imageUrl: string;
  width: number;
  height: number;
  scale: number;
}

const LOGOS: Logo[] = [
  {
    name: "partner1",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/1.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner2",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/2.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner3",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/3.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner4",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/4.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner5",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/5.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner6",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/6.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner7",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/7.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner8",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/8.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner9",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/9.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner10",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/10.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner11",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/11.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner12",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/12.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner13",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/13.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner14",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/14.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner15",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/15.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
  {
    name: "partner16",
    imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/partners/16.png`,
    width: 200,
    height: 100,
    scale: 0.8,
  },
];

const PartnersCarousel: FC = () => {
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));
  const isBelowLg = useMediaQuery(theme.breakpoints.down("lg"));

  const slideWidth = isBelowMd ? 120 : isBelowLg ? 160 : 200;

  const config: SwiperProps = {
    spaceBetween: 30,
    loop: true,
    slidesPerView: "auto",
    modules: [Autoplay],
    grabCursor: false,
    autoplay: {
      delay: 1000,
    },
    allowTouchMove: false,
    breakpoints: {
      900: {
        spaceBetween: 40,
      },
      1200: {
        spaceBetween: 80,
      },
    },
  };

  return (
    <Box
      sx={{
        mb: { xs: 12, md: 14, lg: 20 },
        "& .swiper-wrapper": { alignItems: "center" },
      }}
    >
      {/* <Container>
        <Heading
          heading="Partners & Collaborators"
          subheading="We're proud to work with the most established brands in the Web3 world."
          boxProps={{
            sx: { mb: { xs: 6, md: 10, lg: 12 }, textAlign: "center" },
          }}
        />
      </Container> */}

      <Carousel config={config}>
        {LOGOS.map((logo) => (
          <SwiperSlide key={logo.name} style={{ width: slideWidth }}>
            <Box key={logo.name} sx={styles.carouselItem}>
              <Image
                src={logo.imageUrl}
                alt={logo.name}
                width={logo.width * logo.scale}
                height={logo.height * logo.scale}
                style={{ objectFit: "contain", maxWidth: "100%" }}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Carousel>
    </Box>
  );
};
export default PartnersCarousel;
